module.exports = __webpack_public_path__ + "img/icon_shop_bottom.b6ef188f.png";